module.exports = __webpack_public_path__ + "assets/groceries-default-image-ccfed3.svg";